import { render, staticRenderFns } from "./TheMetrics.vue?vue&type=template&id=f3a08068&"
import script from "./TheMetrics.vue?vue&type=script&lang=ts&"
export * from "./TheMetrics.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f3a08068')) {
      api.createRecord('f3a08068', component.options)
    } else {
      api.reload('f3a08068', component.options)
    }
    module.hot.accept("./TheMetrics.vue?vue&type=template&id=f3a08068&", function () {
      api.rerender('f3a08068', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/TheMetrics.vue"
export default component.exports